import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/style/style.scss';
import { getMerchant, setLang  } from './util/helper';

const merchant = getMerchant();
const i18n = setLang(merchant?.language, merchant?.merchant_name);

const app = createApp(App);
app.use(i18n);
app.use(store);
app.use(router);
app.mount('#app');
